import React, { Component } from "react";
import { Row, Col, Table, Alert, Panel } from "react-bootstrap";
import { msgs } from "src/js/ErrorMessage.js";
import Loader from "src/js/Loader.js";
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import EventTypeForm from "src/component/SafetyMap/EventTypeForm";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class EventStatsInfo extends Component {
  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        <Alert bsStyle="danger">
          <p>{t("Message." + msgs["msg_common_01"])}</p>
        </Alert>
      </div>
    );

    const CountTable = () => {
      return (
        <Table id="event-counts" className="event-data-stats">
        <tbody>
          <tr>
            <th>
              {t('SafetyMap.TotalCounts')}
            </th>
            <td>
              {this.props.safetyMapData.sumCountPerMonth
                ? this.props.safetyMapData.sumCountPerMonth.value
                : 0}
            </td>
          </tr>
          <tr>
            <th>
              {t('SafetyMap.AverageCountsPer100km')}
            </th>
            <td>
              {this.props.safetyMapData.sumCountPerOneHundred
                ? this.props.safetyMapData.sumCountPerOneHundred.value
                : 0}
            </td>
          </tr>
          <tr>
            <th>
              {t('SafetyMap.AverageCountsPerDay')}
            </th>
            <td>
              {this.props.safetyMapData.avgCountPerDay
                ? this.props.safetyMapData.avgCountPerDay.value
                : 0}
            </td>
          </tr>
        </tbody>
      </Table>
      )
    }

    // countTable
    if (!this.props.isSafetyMap) {
      return (
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Error />
          </Col>
        </Row>
      );
    } else
      return (
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Panel id="event-stats">
              {this.props.safetyMapLoading ? (
                <div>
                  <Loader />
                </div>
              ) : (
                <div>
                  <Table id="total-stats" className="event-data-stats">
                    <tbody>
                      <tr>
                        <th>{t('SafetyMap.TotalDistance')}</th>
                        <td>
                          {this.props.safetyMapData.totalDistance
                            ? this.props.safetyMapData.totalDistance.toLocaleString()
                            : 0}
                        </td>
                      </tr>
                      <tr>
                        <th>{t('SafetyMap.AverageDailyDistance')}
                        </th>
                        <td>
                          {this.props.safetyMapData.avgDistancePerDay
                            ? this.props.safetyMapData.avgDistancePerDay
                            : 0}
                        </td>
                      </tr>
                      <tr>
                      <th>{t('SafetyMap.AverageTripsPerDay')}</th>
                        <td>
                          {this.props.safetyMapData.avgTripCountPerDay
                            ? this.props.safetyMapData.avgTripCountPerDay
                            : 0}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <EventTypeForm 
                    eventType={this.props.eventType}
                    selectEventType={this.props.selectEventType}
                  />
                  <CountTable />
                </div>
              )}
            </Panel>
          </Col>
        </Row>
      );
  }
}

export default withTranslation()(EventStatsInfo);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventStatsInfo.js